import React, { useEffect, useState } from 'react';
import Rating from '@mui/material/Rating';
import { MdOutlineEdit } from 'react-icons/md';
import { RiPrinterLine } from 'react-icons/ri';
import { BsThreeDotsVertical } from 'react-icons/bs';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { IoCloseOutline } from 'react-icons/io5';
import { MdError } from 'react-icons/md';
import './style.css';
import { isDateValid } from './utils';
import StarRating from '../../../components/common/rating/StartRating';
import { FeedbackModal } from '../FeedbackModal';
import apiService from 'services/apiService';
import ContractConfirmation from 'components/common/contractConfirmation/ContractConfirmation';

function RatingBar({
  setIsRatingOpen,
  setShowReviewsList,
  name,
  contractEndDate,
  avg,
  contractDetails,
  check = false,
}) {
  const [hasContractExpired, setHasContractExpired] = useState(() =>
    isDateValid(contractEndDate)
  );

  const [same, setSame] = useState('');
  const [disable, setDisable] = useState('');
  const [rejectionReasonModal, setRejectionReasonModal] = useState(false);

  const [reviewModal, setreviewModal] = useState(false);

  const user = JSON.parse(localStorage.getItem('user'));

  const managerRating = contractDetails?.physician?.avg_rating;

  const avgRating = managerRating || managerRating?.avg_rating || 'No Rating';

  React.useEffect(() => {
    let check = isDateValid(contractEndDate);
    setHasContractExpired(check);
    setSame(
      contractDetails?.physician?.ratings?.some(
        (item) => item.hospital_manager_id === user.id
      )
    );

    setDisable(
      contractDetails?.physician?.ratings?.some(
        (item) => item.contract_id === contractDetails._id
      )
    );
  }, [contractEndDate]);

  const capitalizeFirstCharacter = (str) => {
    if (!str) return ''; // Handle empty or undefined strings
    return str.charAt(0).toUpperCase() + str.slice(1);
  };

  console.log('reviewModalreviewModal', contractDetails);

  return (
    <>
      {reviewModal && (
        <FeedbackModal
          Reviews={contractDetails?._id}
          setreviewModal={setreviewModal}
          reviewModal={reviewModal}
        />
      )}

      {rejectionReasonModal && (
        <ContractConfirmation
          isAccept={3}
          onDismiss={() => {
            setRejectionReasonModal(false);
          }}
          contractDetails={{
            reason:
              contractDetails?.reason || contractDetails?.termination_reason,
          }}
        ></ContractConfirmation>
      )}

      <div className="flex flex-row bg-slate-100 justify-between items-center p-4">
        <div className="flex items-center justify-center gap-2">
          <div className="bg-white text-xs font-medium text-[#525866] px-2.5 py-1.5 rounded-md border-1 flex gap-1">
            <span className="rounded-full text-white ">
              <CheckCircleIcon sx={{ fontSize: 16 }} color="success" />
            </span>
            <p className="self-end inline m-0">Active</p>
          </div>
          <h3 className="font-medium text-lg text-[#0A0D14] self-center m-0 ">
            {name}
          </h3>
          <p className="font-medium text-lg m-0">|</p>
          <div className="flex flex-row gap-x-2 mt-1.5">
            <div className="self-end">
              <div>
                {managerRating ? (
                  <div className="flex items-center gap-1 text-yellow-500">
                    {/* Render stars based on avgRating */}
                    <StarRating
                      reviewModal={reviewModal}
                      setreviewModal={setreviewModal}
                      showPreview={true}
                      preview={contractDetails?.physician?.ratings?.length || 0}
                      avgRating={
                        user?.role == 'MoH Manager'
                          ? contractDetails?.physician?.avg_rating
                          : avgRating
                      }
                    />
                  </div>
                ) : (
                  <div class="ml-2 flex">
                    <svg
                      class="w-5 h-5 text-yellow-400"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M12 17.27l6.18 3.73-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73-1.64 7.03L12 17.27z"
                      ></path>
                    </svg>
                    <svg
                      class="w-5 h-5 text-yellow-400"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M12 17.27l6.18 3.73-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73-1.64 7.03L12 17.27z"
                      ></path>
                    </svg>
                    <svg
                      class="w-5 h-5 text-yellow-400"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M12 17.27l6.18 3.73-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73-1.64 7.03L12 17.27z"
                      ></path>
                    </svg>
                    <svg
                      class="w-5 h-5 text-yellow-400"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M12 17.27l6.18 3.73-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73-1.64 7.03L12 17.27z"
                      ></path>
                    </svg>
                    <svg
                      class="w-5 h-5 text-yellow-400"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M12 17.27l6.18 3.73-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73-1.64 7.03L12 17.27z"
                      ></path>
                    </svg>

                    <span class="text-sm text-[#0A0D14] ml-2">0 Ratings</span>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
        {contractDetails?.status === 'rejected' &&
          user?.role == 'hospital_manager' && (
            <div>
              <button
                onClick={() => {
                  setRejectionReasonModal(true);
                }}
                className="flex items-center justify-center gap-2 px-4 py-2 text-[#DF1C41] border-1 border-[#DF1C41] rounded-md hover:bg-red-50 focus:outline-none focus:ring focus:ring-red-200"
              >
                {/* <FaTimes className="text-l" /> */}
                Show reason of rejection
              </button>
            </div>
          )}
        {contractDetails?.status === 'terminated' &&
          user?.role == 'hospital_manager' && (
            <div>
              <button
                onClick={() => {
                  setRejectionReasonModal(true);
                }}
                className="flex items-center justify-center gap-2 px-4 py-2 text-[#DF1C41] border-1 border-[#DF1C41] rounded-md hover:bg-red-50 focus:outline-none focus:ring focus:ring-red-200"
              >
                {/* <FaTimes className="text-l" /> */}
                Show reason of Termination
              </button>
            </div>
          )}

        {hasContractExpired &&
          contractDetails?.status === 'approved' &&
          user?.role == 'hospital_manager' && (
            <div
              className={`flex gap-2 items-center border-2 bg-white 
            ${disable ? 'text-gray-400 border-gray-400 cursor-not-allowed' : 'text-green-600 border-green-600 hover:cursor-pointer'}
            font-medium text-sm rounded-xl px-2.5 py-2`}
              onClick={() => {
                if (!disable) {
                  setIsRatingOpen(true);
                }
              }}
            >
              <MdOutlineEdit />
              <button disabled={disable}>Write Review</button>
            </div>
          )}
        {/* <div className="flex gap-2">
        <div className="bg-white p-2 border-1 border-[#E0E0E0] rounded-md hover:cursor-pointer ">
          <RiPrinterLine />
        </div>
        <div className="bg-white p-2 border-1 border-[#E0E0E0] rounded-md hover:cursor-pointer ">
          <BsThreeDotsVertical />
        </div>
      </div> */}
      </div>

      {hasContractExpired && (
        <div className="bg-[#DF1C41] h-[44px] w-full flex items-center px-2 ">
          <div className="flex basis-full text-center w-full">
            <h3 className="text-sm font-medium text-white  text-center w-full contract-expired">
              Contract is set to expired.
            </h3>
          </div>
          <span
            className="cursor-pointer"
            onClick={() => setHasContractExpired(false)}
          >
            <IoCloseOutline className="text-white" />
          </span>
        </div>
      )}
    </>
  );
}

export default RatingBar;

// <p className="text-sm font-normal text-[#0A0D14] flex gap-x-2 slef-end m-0">
//   4.5 Ratings{" "}
//   <span
//     className="font-medium text-sm text-[#525866] underline  hover:cursor-pointer"
//     onClick={() => {
//       setShowReviewsList(true);
//     }}
//   >
//     18 Reviews
//   </span>
// </p>
